<template>
  <v-container fluid>
    <FormSubmitPopup
      :title="$t('modifyPkgSpecification')"
      :value="value"
      :rightMethod="onSubmitted"
      :leftMethod="() => $emit('input', false)"
      :rightButtonDisabled="!isEmpty"
      small
      hasAlert
    >
      <template v-slot:input>
        <v-layout>
          <v-flex md5>
            <v-text-field
              :label="$t('packageName')"
              :rules="[isDuplicateName]"
              v-model.trim="pkgName"
              class="required_field"
            ></v-text-field>
          </v-flex>
          <v-flex md4>
            <v-btn color="primary" :disabled="!Boolean(pkgName)" @click="addPkg(pkgName)">
              <v-icon dark>add</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-layout justify-space-between>
              <v-flex md7>
                <vite-autocomplete
                  hide-details
                  :items="order.packagingSpecs"
                  :label="$t('SelectPackaging')"
                  item-text="packageName"
                  v-model="order.packaging"
                  return-object
                ></vite-autocomplete>
              </v-flex>
              <v-flex>
                <v-btn
                  dark
                  color="primary"
                  v-if="order.packagingSpecs && order.packagingSpecs.length"
                  @click="deletePkg(order.packaging.packageName)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-layout justify-space-between>
              <v-flex md7>
                <v-text-field
                  hide-details
                  v-model.number="order.packaging.weight"
                  :rules="[
                    fieldIsRequired('weight'),
                    fieldIsOverZero('weight'),
                    isMeasurementMetric ? () => true : fieldIsPkgWeight(order['isOz']),
                  ]"
                  @change="weightLbChange(order)"
                  :label="
                    isMeasurementMetric
                      ? `${$t('weight')}(kg)`
                      : `${$t('weight')}(${
                          order['isOz']
                            ? $t('clickSwitch', { click: 'Oz', change: 'Lbs' })
                            : $t('clickSwitch', { click: 'Lbs', change: 'Oz' })
                        })`
                  "
                >
                  <template v-slot:append>
                    <span
                      v-if="!isMeasurementMetric"
                      @click="order['isOz'] = !order['isOz']"
                      style="cursor: pointer"
                      >{{ order['isOz'] ? 'Oz' : 'Lbs' }}</span
                    >
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex md4>
                <v-text-field
                  :label="$t('packageQty')"
                  :hint="$t('packageQty')"
                  hide-details
                  :rules="[fieldIsInteger('packageQty')]"
                  v-model.number="order.packaging.packageQuantity"
                  @change="packageQtyChange(order)"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout align-center>
          <v-flex xs4 class="mr-3">
            <v-text-field
              class="table-item"
              hide-details
              v-model.number="order.packaging.length"
              :label="$t('L')"
              :suffix="sizeSuffix"
              :rules="[fieldIsRequired('length'), fieldIsOverZero('length')]"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 class="mr-3">
            <v-text-field
              class="table-item"
              hide-details
              :label="$t('W')"
              :suffix="sizeSuffix"
              v-model.number="order.packaging.width"
              :rules="[fieldIsRequired('width'), fieldIsOverZero('width')]"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field
              class="table-item"
              hide-details
              :suffix="sizeSuffix"
              :label="$t('H')"
              v-model.number="order.packaging.height"
              :rules="[fieldIsRequired('height'), fieldIsOverZero('height')]"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout align-center>
          <v-data-table
            :headers="headers"
            hide-actions
            :items="packages"
            style="width: 100%;"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">{{ $t('package') }} {{ props.index + 1 }}</td>
              <td>
                <template v-if="order.packaging.skus && order.packaging.skus[props.index]">
                  <v-chip 
                    
                    :key="index" 
                    v-for="(key, index) in Object.keys(order.packaging.skus[props.index])"
                  >
                    {{ key }} ({{ order.packaging.skus[props.index][key] }})
                    <v-icon @click="closeSku(props.index, key)"  style="cursor:pointer" size="18">close</v-icon>
                  </v-chip>
                </template>
              </td>
              <td>
                <v-btn flat icon @click="showAddSkuPopup(props.index)">
                  <v-icon>add</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <!-- <v-flex>
            
          </v-flex> -->
        </v-layout>
      </template>
    </FormSubmitPopup>

    <FormSubmitPopup
      :title="$t('addSku')"
      v-model="addSkuPopup.show"
      :rightMethod="addSku"
      :rightButtonText="$t('add')"
      @popupClose="addSkuPopup.show = false"
      small
      hasAlert
    >
      <template v-slot:input>
        <v-layout justify-space-between>
          <v-flex md6>
            <v-select
              :items="skus"
              item-text="text"
              :rules="[fieldIsRequired('sku')]"
              v-model="addSkuPopup.sku"
              :label="$t('sku')"
            ></v-select>
          </v-flex>
          <v-flex md4>
            <v-text-field
              :label="$t('quantity')"
              :rules="[fieldIsNumber('quantity'), fieldIsRequired('quantity')]"
              v-model.number="addSkuPopup.quantity"
              class="required_field"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </template>
    </FormSubmitPopup>
  </v-container>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import {checkRules, measurementTools} from '@/utils/tools'

export default {
  name: 'ModifyPkgSpecificationPopup',
  components: {
    FormSubmitPopup
  },
  mixins: [checkRules, measurementTools],
  data () {
    return {
      pkgName: '',
      addSkuPopup: {
        show: false,
        quantity: 1,
        index: -1,
        sku: ''
      }
    }
  },
  methods: {
    closeSku (index, key) {
      const val = this.order.packaging.skus[index]
      delete val[key]
      this.$set(this.order.packaging.skus, index, val)
    },
    addSku () {
      const { sku, quantity, index } = this.addSkuPopup
      if (!this.order.packaging.skus) {
        this.$set(this.order.packaging, 'skus', [])
      }
      if (!this.order.packaging.skus[index]) {
        this.$set(this.order.packaging.skus, index, {})
      }
      const skuQty = this.order.packaging.skus[index][sku] || 0
      this.$set(this.order.packaging.skus[index], sku, skuQty + quantity)
      this.addSkuPopup = {
        show: false,
        quantity: 1,
        index: -1,
        sku: ''
      }
    },
    showAddSkuPopup (index) {
      this.addSkuPopup = {
        show: true,
        quantity: 1,
        index,
        sku: ''
      }
    },
    packageQtyChange (order) {
      order.packagingSpecs && order.packagingSpecs.forEach(item => {
        if (item.packageName === order.packaging.packageName) {
          item.packageQuantity = order.packaging.packageQuantity
        }
      })
    },
    weightLbChange (order) {
      order.packagingSpecs && order.packagingSpecs.forEach(item => {
        if (item.packageName === order.packaging.packageName) {
          item.weight = order.packaging.weight
        }
      })
    },
    deletePkg (packageName) {
      this.order.packagingSpecs.splice(
        this.order.packagingSpecs.findIndex(
          item => item.packageName === packageName
        ),
        1
      )
      this.order.packaging = this.order.packagingSpecs[0] || {}
    },
    addPkg (pkgName) {
      let pkg = {
        packageName: pkgName,
        weight: 0,
        packageQuantity: 1,
        length: 0,
        width: 0,
        height: 0,
        skus: []
      }
      !this.order.packagingSpecs && (this.order.packagingSpecs = [])
      this.order.packagingSpecs.push(pkg)
      this.order.packaging = pkg
      this.pkgName = ''
    },
    async onSubmitted () {
      try {
        const convertPkg = {
          ...this.order.packaging,
          ...this.convertPackagingSize(this.order.packaging, this.order.isMeasurementMetric, false, true),
          weight: this.convertWeight(this.order.packaging.weight, this.order.isMeasurementMetric, true)
        }
        this.order.packagingSpecs?.length && this.order.packagingSpecs.forEach(pkg => {
          if (pkg.packageName === this.order.packaging.packageName) {
            Object.assign(pkg, this.order.packaging)
          }
          Object.assign(pkg, {
            ...pkg,
            ...this.convertPackagingSize(this.order.packaging, this.order.isMeasurementMetric, false, true),
            weight: this.convertWeight(this.order.packaging.weight, this.order.isMeasurementMetric, true)
          })
          pkg.weight = this.order.isOZ ? (pkg.weight / 16) : pkg.weight
        })
        this.order.isMPS = this.order.packagingSpecs?.length > 1 || this.order.packagingSpecs[0]?.packageQuantity > 1
        const payload = { ...this.order, packaging: convertPkg }
        const inValidSkus = this.order.items.filter(item => {
          const { sku, quantityPurchased, quantityShipped } = item
          const qty = quantityPurchased - quantityShipped
          const targetPkgs = convertPkg.packageName ? this.order.packagingSpecs : [convertPkg]
          const sum = targetPkgs.reduce((sum, pkg) => {
            const { skus = [] } = pkg
            skus.forEach(item => {
              Object.entries(item).forEach(([key, value]) => {
                const target = key === sku
                if (target) {
                  sum = sum + value
                }
              })
            })
            return sum
          }, 0)
          return qty < sum
        })
        if (inValidSkus.length) {
          alert(`${inValidSkus.map(item => item.sku).join(',')} quantity exceeds`)
          return
        }
        await this.$store.dispatch('modifyPkgSpecification', payload)
        this.$emit('updateOrders', payload)
        this.$emit('input', false)
      } catch (error) {
        throw error
      }
    }
  },
  computed: {
    packages () {
      return new Array(this.order.packaging.packageQuantity).fill(0)
    },
    headers () {
      return [
        { text: this.$t('package'), value: '', align: 'center', sortable: false, width: '30%' },
        { text: this.$t('skus'), value: 'sku', align: 'center', sortable: false, width: '60%' },
        { text: this.$t('action'), value: 'action', align: 'center', sortable: false, width: '10%' }
      ]
    },
    skus () {
      const skus = this.order.items || []
      return skus.map(sku => {
        return {
          text: sku.sku,
          qty: sku.quantityPurchased - sku.quantityShipped
        }
      }).filter(sku => sku.qty !== 0)
    },
    isDuplicateName () {
      let isDuplicateName = this.order.packagingSpecs?.some((pkg) => this.pkgName === pkg.packageName) || false
      return !isDuplicateName || this.$t('duplicatePkgName')
    },
    isEmpty () {
      const { packageName } = this.order.packaging
      if (!packageName) {
        return !!(this.order.packaging.length && this.order.packaging.width && this.order.packaging.height &&
       this.order.packaging.weight && this.order.packaging.packageQuantity === 1) 
      }
      return !!(this.order.packaging.length && this.order.packaging.width && this.order.packaging.height &&
       this.order.packaging.weight && this.order.packaging.packageQuantity)
    },
    isMeasurementMetric () {
      return !!this.$store.getters.isMeasurementMetric
    },
    sizeSuffix () {
      return this.isMeasurementMetric ? 'cm' : '"'
    }
  },
  props: {
    value: Boolean,
    order: {
      type: Object,
      default () {
        return {
          packaging: {},
          packagingSpecs: []
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModifyPkgSpecificationPopup.vue